import { render } from "./StoreChainTable.vue?vue&type=template&id=471f75e8"
import script from "./StoreChainTable.vue?vue&type=script&lang=js"
export * from "./StoreChainTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__